import React, { useEffect, useState } from 'react'
import { useAuth0 } from '@auth0/auth0-react'
import MenuItem from '@material-ui/core/MenuItem'
import backend from "../../utils/backend"


function LogoutButton(props) {
  const { logout } = useAuth0()
  const [authProps, setAuthProps] = useState({})

  useEffect(() => {
    if (!authProps.clientId) {
      getAuthProps()
    }
  }, [authProps])

  async function getAuthProps() {
    try {
      const respons = await backend.getAuthProps()
      setAuthProps(respons.clientId)
    } catch (e) {
      console.error('Error get Auth props', e)
    }
  }

  return  (
      <MenuItem className={props.className} onClick={async () => {
        try {
          // Call server logout endpoint to invalidate tokens
          const token = localStorage.getItem('token')
          const refreshToken = localStorage.getItem('refresh_token')
          if (token) {
            await backend.logout(refreshToken)
          }
        } catch (error) {
          console.error('Server logout failed:', error)
          // Continue with client-side logout even if server logout fails
        }

        // Auth0 logout
        await logout({
          logoutParams: {
            returnTo: window.location.origin,
            client_id: authProps
          }
        });

        // Clear local storage
        localStorage.removeItem('token')
        localStorage.removeItem('refresh_token')

        // Navigate and close
        props.history.push('/')
        props.handleClose()
      }}>Logout</MenuItem>
  );
}

export default LogoutButton
